export default "__VITE_PUBLIC_ASSET__39ddf136__"